const triggerStaff = ( trigger ) => {
    const content = trigger.closest('.staff__person').querySelector('.staff__content ');
    if ( content.classList.contains('staff__content--show') ) {
        trigger.classList.remove('staff__trigger--up')
        trigger.classList.add('staff__trigger--down')
        content.classList.remove('staff__content--show')
        content.classList.add('staff__content--hidden')
    } else if ( content.classList.contains('staff__content--hidden') ) {
        trigger.classList.remove('staff__trigger--down')
        trigger.classList.add('staff__trigger--up')
        content.classList.remove('staff__content--hidden')
        content.classList.add('staff__content--show')
    }
}